
import { defineComponent, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import ValidateInput, { RulesProp } from '../components/ValidateInput.vue'
import ValidateForm from '../components/ValidateForm.vue'
import createMessage from '../components/createMessage'
import axios from 'axios'

export default defineComponent({
  name: 'Login',
  components: {
    ValidateInput,
    ValidateForm
  },
  data() {
    return {
      resetParams: {
        isShow: false,
        accountVal: '',
        passwordVal: '',
        newPasswordVal: '',
        newPassword2Val: ''
      }
    }
  },
  methods: {
    handleReset() {
      if (!this.resetParams.accountVal || !this.resetParams.passwordVal || !this.resetParams.newPasswordVal || !this.resetParams.newPassword2Val) {
        return
      }
      if (this.resetParams.newPasswordVal !== this.resetParams.newPassword2Val) {
        createMessage('两次输入的新密码不一致', 'error')
        return
      }
      const serve = axios.create()
      const request = serve({
        url: '/user/sjyuser/editPsw',
        method: 'POST',
        data: {
          userCode: this.resetParams.accountVal,
          userPassword: this.resetParams.passwordVal,
          userUpdatePassword: this.resetParams.newPasswordVal
        }
      })
      request.then(res => {
        if (res.data.code === 200) {
          createMessage('操作成功', 'success')
          this.resetParams.isShow = false
        } else {
          createMessage(res.data.msg, 'error')
        }
      })
    }
  },
  setup () {
    const openPsw = ref('')
    const accountVal = ref('')
    const router = useRouter()
    const store = useStore()
    const accountRules: RulesProp = [
      {
        type: 'required',
        message: '账号不能为空'
      }
    ]
    const passwordVal = ref('')
    const passwordRules: RulesProp = [
      {
        type: 'required',
        message: '密码不能为空'
      }
    ]
    const onFormSubmit = (result: boolean) => {
      if (result) {
        localStorage.setItem('userCode', accountVal.value)
        localStorage.setItem('userPassWord', passwordVal.value)
        const payload = {
          userCode: accountVal.value,
          userPassWord: passwordVal.value
        }
        store.dispatch('loginAndFetch', payload).then(data => {
          console.log(data)
          createMessage('登录成功 2秒后跳转首页', 'success')
          setTimeout(() => {
            router.push('/home')
          }, 2000)
        }).catch(e => {
          console.log(e)
          createMessage(store.state && store.state.error && store.state.error.msg, 'error')
        })
      }
    }
    const indexBgUrl = ref('')
    const loadAdv = () => {
      store.dispatch('loadAdv', { adPlace: 'AD_HNSJY_PC' }).then(() => {
        indexBgUrl.value = store.getters.getIndexBgUrl()
      })
    }
    loadAdv()
    return {
      accountRules,
      accountVal,
      passwordVal,
      openPsw,
      passwordRules,
      indexBgUrl,
      onFormSubmit
    }
  }
})
